import { Link } from "react-router-dom";
import React, { useState } from "react";
import { auth, provider, signInWithPopup, createUserWithEmailAndPassword } from "../firbase";
import { useNavigate } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const Register = () => {
  const navigate = useNavigate();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [name, setName] = useState('');

  const handleGoogleLogin = () => {
    signInWithPopup(auth, provider)
      .then((result) => {
        console.log(result.user);
        navigate("/"); // Redirect to GPT page after successful login
      })
      .catch((error) => {
        console.error(error);
        toast.error("Google sign-in failed. Please try again.");
      });
  };

  const handleRegister = (e) => {
    e.preventDefault();
    if (!name || !email || !password) {
      toast.error("Please fill in all fields.");
      return;
    }
  
    createUserWithEmailAndPassword(auth, email, password)
      .then((userCredential) => {
        const user = userCredential.user;
        console.log('User registered:', user);
        
        toast.success("Registration successful!");
        
        // Delay the navigation to allow the toast to show
        setTimeout(() => {
          navigate("/"); // Redirect to GPT page after successful registration
        }, 1500); // 1.5 seconds delay
      })
      .catch((error) => {
        console.error(error);
        toast.error("Registration failed. Please check your details and try again.");
      });
  };

  return (
    <div className="h-screen overflow-hidden">
      <ToastContainer />
      <div className="min-h-screen bg-gray-100 py-6 flex flex-col justify-center sm:py-12">
        <div className="relative py-3 sm:w-[90%] md:w-[50%] sm:mx-auto">
          <div className="absolute inset-0 bg-gradient-to-tl from-[#FF8A08] to-[#FF6500] shadow-lg transform -skew-y-6 sm:skew-y-0 sm:-rotate-6 sm:rounded-3xl"></div>
          <div className="relative px-4 py-10 bg-white shadow-lg sm:rounded-3xl">
            <div className="max-w-lg mx-auto">
              <div>
                <h1 className="text-2xl font-semibold">Sign Up</h1>
              </div>
              <form onSubmit={handleRegister}>
                <div className="divide-y divide-gray-200">
                  <div className="py-8 text-base leading-6 space-y-4 text-gray-700 sm:text-lg sm:leading-7">
                    <div className="relative">
                      <input
                        autoComplete="off"
                        id="name"
                        name="name"
                        type="text"
                        value={name}
                        onChange={(e) => setName(e.target.value)}
                        className="peer placeholder-transparent h-10 rounded w-full border-b-2 border-gray-300 sm:text-sm md:text-[16px] text-gray-900 focus:outline-none focus:border-rose-600  mt-2"
                        placeholder="Name"
                      />
                      <label
                        htmlFor="name"
                        className="absolute left-0 -top-3.5 text-gray-600 text-sm peer-placeholder-shown:text-base peer-placeholder-shown:text-gray-440 peer-placeholder-shown:top-2 transition-all peer-focus:-top-3.5 peer-focus:text-gray-600 peer-focus:text-sm"
                      >
                        Enter Your Name
                      </label>
                    </div>
                    <div className="relative">
                      <input
                        autoComplete="off"
                        id="email"
                        name="email"
                        type="text"
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                        className="peer placeholder-transparent h-10 rounded w-full border-b-2 border-gray-300 sm:text-sm md:text-[16px] text-gray-900 focus:outline-none focus:border-rose-600  mt-2"
                        placeholder="Email address"
                      />
                      <label
                        htmlFor="email"
                        className="absolute left-0 -top-3.5 text-gray-600 text-sm peer-placeholder-shown:text-base peer-placeholder-shown:text-gray-440 peer-placeholder-shown:top-2 transition-all peer-focus:-top-3.5 peer-focus:text-gray-600 peer-focus:text-sm"
                      >
                        Email Address
                      </label>
                    </div>
                    <div className="relative">
                      <input
                        autoComplete="off"
                        id="password"
                        name="password"
                        type="password"
                        value={password}
                        onChange={(e) => setPassword(e.target.value)}
                        className="peer placeholder-transparent rounded h-10 w-full border-b-2 border-gray-300 sm:text-sm md:text-[16px] text-gray-900 focus:outline-none focus:border-rose-600  mt-2"
                        placeholder="Password"
                      />
                      <label
                        htmlFor="password"
                        className="absolute left-0 -top-3.5 text-gray-600 text-sm peer-placeholder-shown:text-base peer-placeholder-shown:text-gray-440 peer-placeholder-shown:top-2 transition-all peer-focus:-top-3.5 peer-focus:text-gray-600 peer-focus:text-sm"
                      >
                        Password
                      </label>
                    </div>
                    <div className="relative">
                      <button type="submit" className="bg-gradient-to-tl from-[#FF8A08] to-[#FF6500] text-white rounded px-4 py-1">
                        Sign up
                      </button>
                    </div>
                    <p>
                      Already have an account?{" "}
                      <Link to="/login">
                        <span className="text-[#FF6500]">Login</span>
                      </Link>
                    </p>
                  </div>
                </div>
              </form>
              {/* Google Login Button (optional) */}
            <div className="w-full flex justify-center">
                <button
                  onClick={handleGoogleLogin}
                  className="flex items-center bg-white border border-gray-300 rounded-lg shadow-md px-6 py-2 text-sm font-medium text-gray-800 hover:bg-gray-200 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-gray-500"
                >
                  <svg
                    className="h-6 w-6 mr-2"
                    xmlns="http://www.w3.org/2000/svg"
                    xmlnsXlink="http://www.w3.org/1999/xlink"
                    width="800px"
                    height="800px"
                    viewBox="-0.5 0 48 48"
                    version="1.1"
                  >
                    <title>Google-color</title>
                    <g id="Icons" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                      <g id="Color-" transform="translate(-401.000000, -860.000000)">
                        <g id="Google" transform="translate(401.000000, 860.000000)">
                          <path
                            d="M9.82727273,24 C9.82727273,22.4757333 10.0804318,21.0144 10.5322727,19.6437333 L2.62345455,13.6042667 C1.08206818,16.7338667 0.213636364,20.2602667 0.213636364,24 C0.213636364,27.7365333 1.081,31.2608 2.62025,34.3882667 L10.5247955,28.3370667 C10.0772273,26.9728 9.82727273,25.5168 9.82727273,24"
                            fill="#FBBC05"
                          ></path>
                          <path
                            d="M23.7136364,10.1333333 C27.025,10.1333333 30.0159091,11.3066667 32.3659091,13.2266667 L39.2022727,6.4 C35.0363636,2.77333333 29.6954545,0.533333333 23.7136364,0.533333333 C14.4268636,0.533333333 6.44540909,5.84426667 2.62345455,13.6042667 L10.5322727,19.6437333 C12.3545909,14.112 17.5491591,10.1333333 23.7136364,10.1333333"
                            fill="#EB4335"
                          ></path>
                          <path
                            d="M23.7136364,37.8666667 C17.5491591,37.8666667 12.3545909,33.888 10.5322727,28.3562667 L2.62345455,34.3946667 C6.44540909,42.1557333 14.4268636,47.4666667 23.7136364,47.4666667 C29.4814545,47.4666667 34.6554545,45.5146667 38.7906818,42.0765333 L31.2314091,36.2496 C29.0951136,37.595982 26.4433818,38.3416482 23.7147955,38.3416482"
                            fill="#34A853"
                          ></path>
                          <path
                            d="M46.1454545,24.5333333 C46.1454545,23.0277333 45.9811364,21.4666667 45.7227273,20.0448 L23.7136364,20.0448 L23.7136364,28.3557333 L35.8831818,28.3557333 C35.3542727,31.1248 33.7409091,33.528 31.2314091,35.0586667 L38.7906818,40.8856 C43.2461364,36.9178667 46.1454545,31.408 46.1454545,24.5333333"
                            fill="#4285F4"
                          ></path>
                        </g>
                      </g>
                    </g>
                  </svg>
                  Sign up with Google
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Register;
